import ChangePasswordError from '@components/ChangePassword/Error';
import ChangePasswordInstructions from '@components/ChangePassword/Instructions';
import ChangePasswordSuccess from '@components/ChangePassword/Success';
import useBodyClass from '@components/Hooks/useBodyClass';
import useGlobalState from '@components/Hooks/useGlobalState';
import useParams from '@components/Hooks/useParams';
import Termite from '@divtel/termite';
import Fader from '@Shared/Fader';
import React from 'react';
import { Col, Container as Grid, Row } from 'react-bootstrap';
import SetPasswordForm from './Form';


const SetPassword: React.FC = () => {

  useBodyClass(['set-password-page']);
  const [store,] = useGlobalState();

  const params = useParams();

  return (
    // @ts-ignore
    <Termite app='Reset Password' noSession>
      <div className='main-section'>
        <Fader>
          <Grid style={{ paddingTop: 30 }}>
            <Row>
              <Col sm={12}>
                <h2>{params.email}</h2>
              </Col>
            </Row>
            <ChangePasswordError />
            <ChangePasswordSuccess />
            {!store.change_password?._info.success ? (
              <Row>
                <Col sm={6}>
                  <SetPasswordForm />
                </Col>
                <Col sm={6}>
                  <ChangePasswordInstructions />
                </Col>
              </Row>
            ) : null}
          </Grid>
        </Fader>
      </div>
    </Termite >
  );
}

export default SetPassword;